import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useGetUser } from 'src/hooks';

export const useChatHistory = () => {
  // TODO: Remove this flag after the feature is fully released
  const flagEnabled = useFeatureFlagEnabled('goodbyeMyNinja');
  const { isTeamsTier, isCreditTier } = useGetUser();

  return {
    isNinjaRetired: flagEnabled && (!isTeamsTier || isCreditTier),
  };
};
